import { apiClient } from './apiClient';
import { Domain, DomainCreate, DomainUpdate, DomainResponse } from '../types';

export const domainService = {
  async list(): Promise<Domain[]> {
    const response = await apiClient.get<Domain[]>('/admin/domains');
    return response.data;
  },

  async create(data: DomainCreate): Promise<DomainResponse> {
    const response = await apiClient.post<DomainResponse>('/admin/domains', data);
    return response.data;
  },

  async update(code: string, data: DomainUpdate): Promise<DomainResponse> {
    const response = await apiClient.put<DomainResponse>(`/admin/domains/${code}`, data);
    return response.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/admin/domains/${code}`);
  }
};
